import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import IntelliaxService from "@/assets/js/services/IntelliaxService";
import store from "@/store";

const About = (resolve: (...modules: any[]) => void) => require(['../views/About.vue'], resolve);
const StartApp = (resolve: (...modules: any[]) => void) => require(['../views/StartApp.vue'], resolve);
const Start = (resolve: (...modules: any[]) => void) => require(['../views/Start.vue'], resolve);
const CreateLink = (resolve: (...modules: any[]) => void) => require(['../views/CreateLink.vue'], resolve);
const Login = (resolve: (...modules: any[]) => void) => require(['../views/Login.vue'], resolve);

const Orders = (resolve: (...modules: any[]) => void) => require(['../views/orders/Orders.vue'], resolve);

const Artikel = (resolve: (...modules: any[]) => void) => require(['../views/artikel/Artikel.vue'], resolve);

const UserProfile = (resolve: (...modules: any[]) => void) => require(['../views/UserProfile.vue'], resolve);

Vue.use(VueRouter);

export const routes: Array<RouteConfig> = [
    {
        path: '/bestellungen',
        component: Orders,
        meta: {
            isSafe: true,
            showInMenu: true,
            pageTitle: 'Bestellungen',
            pageIcon: 'ordermanager-order',
        }
    },
    {
        path: '/meineartikel',
        component: Artikel,
        meta: {
            isSafe: true,
            showInMenu: true,
            pageTitle: 'meine Artikel',
            pageIcon: 'ordermanager-item',
        }
    },
];

const otherRoutes: Array<RouteConfig> = [
    {
        path: '/profile',
        component: UserProfile,
        meta: {
            isSafe: true,
            showInMenu: false,
            pageTitle: 'Benutzerprofil',
            pageIcon: 'ordermanager-order',
        }
    },
    {
        path: '/fail',
        component: Start,
        meta: {
            isSafe: false,
            showInMenu: false,
            pageTitle: 'Fehler',
            pageIcon: 'ordermanager-order',
        }
    },
    {
        path: '/About',
        name: 'About',
        component: About,
        meta: {
            showInMenu: false,
            isSafe: false,
            pageTitle: 'Version',
            pageIcon: 'fa-question',
        },
    },
    {
        path: '/start',
        name: 'start',
        component: StartApp,
        meta: {
            showInMenu: false,
            isSafe: false,
            pageTitle: 'Start',
        },
    },
    {
        path: '/util/createLink',
        component: CreateLink,
        meta: {
            showInMenu: false,
            isSafe: false,
            pageTitle: 'B2B Link erzeugen',
        }
    },
    {
        path: '/login',
        component: Login,
        meta: {
            showInMenu: false,
            isSafe: false,
            pageTitle: 'Anmelden',
        }
    },
    {
        path: '/:urlparam',
        name: "insertServiceUrl",
        component: Start,
        meta: {
            showInMenu: false,
            isSafe: false,
            pageTitle: 'Start',
            pageIcon: 'ordermanager-order',
        }
    },
    {
        path: '*',
        redirect: "/login"
    },
];

const router = new VueRouter({
    mode: 'history',
    routes: routes.concat(otherRoutes),
});

router.beforeEach(async (to, from, next) => {
    try {

        if (to.path.toLowerCase() === "/fail") {
            return next();
        }
        if (to.path.toLowerCase() === "/util/createlink") {
            return next();
        }

        if (to.path.toLowerCase() === "/login") {
            const serviceUrl = store.getters["Auth/serviceUrl"];
            if (!serviceUrl) {
                return next("/fail");
            }
            if (serviceUrl && store.getters["Auth/authToken"]) {
                return next("/bestellungen");
            }
            return next();
        }

        if (to.name === "insertServiceUrl") {
            if (to.params.urlparam) {
                try {
                    const jsonParam = atob(to.params.urlparam);
                    const serviceUrl = JSON.parse(jsonParam).surl;
                    if (!serviceUrl) {
                        return next("/fail");
                    }
                    store.commit("Auth/setServiceUrl", serviceUrl);
                    const result = await IntelliaxService.getCustomizedInfo(serviceUrl);

                    store.commit("Base/setIcon", result?.header?.logo);
                    store.commit("Base/setSmallIcon", result?.header?.logoSmall);
                    store.commit("Base/setFooterLinks", result?.footer?.links);
                    store.commit("Base/setFooterCopyright", result?.footer?.text?.copyright);
                    return next({
                        path: '/login',
                        replace: true
                    });
                } catch (e: any) {
                    return next("/fail");
                }
            }
            return next("/fail");
        } else {

            if (to?.meta?.isSafe) {
                if (!store.getters["Auth/serviceUrl"]) {
                    return next("/fail");
                } else {
                    try {
                        if (!await Vue.ports.b2bAuth.keepAlive()) {
                            throw new Error('keepAlive failed');
                        }
                    } catch (e: any) {
                        await Vue.ports.b2bAuth.logout();
                        store.commit("Auth/setAuthToken", '');
                        store.commit("Base/setCaller", "");
                        return next("/login");
                    }
                }
                // safe route
                return next();
            } else {
                if (!store.getters["Auth/serviceUrl"]) {
                    return next("/fail");
                }
                // not safe route
                return next();
            }
        }
    } catch (e: any) {
        return next();
    }

});

export default router;
